import {CustomersDao} from '../../dao';
import {ErrorModel} from '../../models';
import {SERVICE_CODE} from './_serviceCode';

const FUNCTION_CODE = 'GET_DEAL_RECIPIENTS';

export async function getDealRecipients(
    userData: Record<string, string>,
    dealId: number
) {
    try {
        const recipients = await CustomersDao.getDealRecipients(userData.userToken, dealId);

        return recipients;
    }
    catch (error) {
        throw ErrorModel.newError({
            code: `${SERVICE_CODE}/${FUNCTION_CODE}/ERROR`,
            message: 'Une erreur est survenue lors de la récupération de la liste des destinataires de l\'affaire.',
            error: error
        });
    }
}
